import { render, staticRenderFns } from "./NotificationsDetail.vue?vue&type=template&id=163650a7&scoped=true"
import script from "./NotificationsDetail.vue?vue&type=script&lang=js"
export * from "./NotificationsDetail.vue?vue&type=script&lang=js"
import style0 from "./NotificationsDetail.vue?vue&type=style&index=0&id=163650a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163650a7",
  null
  
)

export default component.exports